<template>
  <div id="container" style="    width: 100%;    padding: 20px 40px;">
    <a-spin :spinning="reloading" :tip="loading == true ? '正在导出中' : ''">
      <div style="display: flex;
   align-items: center;">
        <a-range-picker format="YYYY-MM-DD HH:mm:ss" show-time v-model:value="rangeTime" @change="changeTime" />
        <div style='margin-left: auto;'>
          <a @click="hasSelected ? toExport() : null" :class="hasSelected ? 'action' : 'noaction'">导出</a>
          <a @click="toAllRead" style="margin-left: 20px;">一键全已读</a>
          <a-button :loading="confrimLoading" type="primary" style="width: 100px;margin-left: 20px;"
            @click="toSelectRead" :disabled="!hasSelected">
            一键已读
          </a-button>
        </div>
      </div>
      <div  class="scrollView">
        <a-table :columns="columns" :data-source="tableList" bordered class="tablestyle commentPageStyle"
          :pagination="false" id="commentPage" :scroll="{ y: scrollHeight }" ref="commentPage">
          <template #headerCell="{ title, column }">
            <template v-if="title == '' && column.dataIndex != 'rowselection1'">
              <a-checkbox v-model:checked="state.checkAll" :indeterminate="state.indeterminate"
                @change="onCheckAllChange"></a-checkbox>

            </template>

          </template>
          <template #bodyCell="{ column, text, record, index }">
            <template v-if="['clientName', 'comment', 'createTime'].includes(column.dataIndex)">
              <a-tooltip placement="topLeft" :title="record.title">

                <div style=" word-break: break-all;"><span style="word-break: break-all;">{{ text }}</span></div>
              </a-tooltip>

            </template>
            <template v-if="'rowselection' == column.dataIndex">
              <a-checkbox v-if="record.checkbox != null" v-model:checked="record.checkbox"
                @change="onCheckChange($event, record)"></a-checkbox>

            </template>
            <template v-if="'rowselection1' == column.dataIndex">
              <a-checkbox v-model:checked="record.checkboxExport" :disabled="record.checkboxExportDisabled"
                :indeterminate="record.checkboxExportInterminate"
                @change="onCheckChangeExport($event, record)"></a-checkbox>

            </template>


          </template>

        </a-table>
        <div style="display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;">
          <span style="margin-right: 10px;">共{{ pagination.total }} 条</span> <a-pagination
            v-model:current="pagination.current" v-model:page-size="pagination.pageSize"
            :page-size-options="pagination.pageSizeOptions" :total="pagination.total" show-size-changer
            @change="handleTableChange" size="medium" />
        </div>
        <div>
        </div>
      </div>
    </a-spin>
  </div>
  <!--<a-modal  v-model:visible="visible" :bodyStyle="{height:'90%',width:'500px'}">
       <iframe src="https://www.enplus.org.cn/vuePostertest/#/?id=129512&companyId=32&loading=true"></iframe>
    </a-modal>-->
</template>
<script>
import { readComment, readAllComment } from '../../views/js/index'
import { allCommentPage, downloadComment } from './js/index'
import { reactive, watch, ref, onMounted, h, nextTick } from 'vue'
import store from '@/store'
import dayjs from 'dayjs'
import { message } from 'ant-design-vue/lib/components'
export default {
  name: 'readPage',
  setup() {
    watch(() => store.getters.company, (val) => {
      if (val && val != '') {
        var height = document.getElementById('container').offsetHeight
        scrollView.value = { height: (height - 40) + 'px', overflow: 'auto' }
        pagination.companyId = store.getters.company.companyId
      
        toShowTable()
      }
    })
    const toAllRead = () => {
      if (reloading.value == false) {
        reloading.value = true
        readAllComment({ id: store.getters.company.companyId }).then(res => {
          if (res.msg == '处理成功') {

            message.success('处理成功')
            for (var i in tableList.value) {
              tableList.value[i].readStatus = true
              if (tableList.value[i].checkbox != null)
                tableList.value[i].checkbox = false
            }


            toRestCheckBox()
          }

          else message.error('处理失败')
          reloading.value = false
        }).catch(() => {
          reloading.value = false
        })
      }


      //readComment({ id: store.getters.company.companyId })
    }


    onMounted(() => {
      rangeTime.value = ['', '']
      var height = document.getElementById('container').offsetHeight
      //scrollView.value = { height: (height - 60) + 'px', overflow: 'auto' }
      scrollHeight.value = height - 180
      if (store.getters.company) {
        pagination.companyId = store.getters.company.companyId
        toShowTable()
        //toGetReadComment()
      }
    })
    const originDataSource = ref([])
    const toShowTable = () => {
      state.indeterminate = hasSelected.value = state.checkAll = false
      reloading.value = true
      var startTime = ''
      var endTime = ''
      if (rangeTime.value && rangeTime.value[0] != '') {
        startTime = dayjs(rangeTime.value[0]).format('YYYY-MM-DD HH:mm:ss')
        endTime = dayjs(rangeTime.value[1]).format('YYYY-MM-DD HH:mm:ss')

      }
      var postDataList = { company: pagination.companyId, current: pagination.current, size: pagination.pageSize, startTime: startTime, endTime: endTime }
      postData.value = postDataList
      allCommentPage(postDataList).then((res) => {
        var titleId = 0
        pagination.total = res.data.total
        var list = []
        var currentItem
        var current = 0
        for (var i in res.data.records) {

          var title = res.data.records[i].title


          for (var j in res.data.records[i].commentTreeList) {
            res.data.records[i].commentTreeList[j]['title'] = title
            res.data.records[i].commentTreeList[j]['checkbox'] = false
            res.data.records[i].commentTreeList[j]['titleId'] = titleId
            res.data.records[i].commentTreeList[j]['one'] = true
            currentItem = (postDataList.current - 1) * pagination.pageSize + current + 1
            res.data.records[i].commentTreeList[j]['current'] = currentItem
            res.data.records[i].commentTreeList[j]['checkboxExport'] = false
            res.data.records[i].commentTreeList[j]['checkboxExportDisabled'] = true
            res.data.records[i].commentTreeList[j]['checkboxExportInterminate'] = false
            list.push(res.data.records[i].commentTreeList[j])
            if (res.data.records[i].commentTreeList[j].replyComments) {
              for (var jj in res.data.records[i].commentTreeList[j].replyComments) {
                res.data.records[i].commentTreeList[j].replyComments[jj]['checkboxExport'] = false
                res.data.records[i].commentTreeList[j].replyComments[jj]['checkboxExportDisabled'] = true
                res.data.records[i].commentTreeList[j].replyComments[jj]['title'] = title
                res.data.records[i].commentTreeList[j].replyComments[jj]['titleId'] = titleId
                res.data.records[i].commentTreeList[j].replyComments[jj]['current'] = currentItem
                res.data.records[i].commentTreeList[j].replyComments[jj]['comment'] = "回复 " + res.data.records[i].commentTreeList[j].clientName + " : " + res.data.records[i].commentTreeList[j].replyComments[jj]['comment']
                list.push(res.data.records[i].commentTreeList[j].replyComments[jj])
              }
            }



          }
          titleId++
          current++
        }
        originDataSource.value = res.data.records

        tableList.value = list
        console.log(list, ' tableList.value')

        reloading.value = false
      })
    }
    const pagination = reactive({
      current: 1,
      pageSizeOptions: ['10', '20', '50'],
      pageSize: 10,
      companyId: '',
      total: 0,

    })
    const tableList = ref([])
    const scrollView = ref('')
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const handleScroll = (e) => {
      let scrollTop = e.target.scrollTop; //滑入屏幕滚动条滚动时，距离顶部的距离
      let windowHeitht = e.target.clientHeight; //能看到的页面的高度
      let scrollHeight = e.target.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let total = scrollTop + windowHeitht
      if (scrollHeight - total < 20) {
        if (articleList.value.length != pagination.total) {
          if (reloading.value == false) {
            pagination.current = pagination.current + 1
            toShowTable()
          }
        }
      }
    }
    const reloading = ref(false)
    const visible = ref(true)
    const rangeTime = ref(['', ''])
    const changeTime = () => {


      tableList.value = []
      pagination.current = 1
      toShowTable()

    }
    const scrollY = ref(0)
    const toSearchUser = (val) => {
      pagination.current = 1

      tableList.value = []
      toShowTable()
    }
    const toExport = () => {
      if (reloading.value == false) {
        reloading.value = loading.value = true
        var list = tableList.value.filter(item => item.checkboxExport == true).map((item => { return item.articleCommentId }))
        downloadComment(list).then(res => {


          const data = res.data;
          var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }); // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = postData.value.startTime + "-" + postData.value.endTime + '-评论'; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载


          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉blob对象
          reloading.value = loading.value = false
          for (var i in tableList.value) {
            if (tableList.value[i].checkbox != null) tableList.value[i].checkbox = false
            if (tableList.value[i].checkboxExportInterminate != null) tableList.value[i].checkboxExportInterminate = false
            tableList.value[i].checkboxExport = false
            tableList.value[i].checkboxExportDisabled = true
          }
          nextTick(() => {
            toWatchTableList()
          })


        }).catch(() => {
          reloading.value = loading.value = false
        })
      }

    }
    const loading = ref(false)
    const postData = ref()
    const columns = ref([
      {
        dataIndex: "rowselection",
        title: '',
        customCell: (record, index) => {

          if (index == tableList.value.findIndex((item) => item.title == record.title)) {
            return {

              rowSpan: tableList.value.filter(
                (item) => item.title == record.title
              ).length

            }
          }
          else {

            return {

              rowSpan: 0

            }
          }
        },
        width: "5%",
        align: 'center'
      },
      {

        title: " 序号 ",
        // render: (text, record, index) => `${index + 1}`,  //每一页都从1开始


        customRender: ({ record, index }) => {
          var obj

          if (index == tableList.value.findIndex((item) => item.title == record.title)) {
            obj = {
              children: h(
                "span",

                record.current
              ),
              props: {
                rowSpan: tableList.value.filter(
                  (item) => item.title == record.title
                ).length
              },
            };
          }
          else {

            obj = {
              children: h(
                "span",

                ""
              ),
              props: {
                rowSpan: 0
              },
            };
          }



          return obj;
        },
        width: "7%",
        align: 'center'
        //当前页数减1乘以每一页页数再加当前页序号+1
      },
      {
        dataIndex: "title",
        key: "title",
        title: "文章标题",
        align: 'center',

        customRender: ({ record, index }) => {
          var obj

          if (index == tableList.value.findIndex((item) => item.title == record.title)) {
            obj = {
              children: h(
                "div",

                record.title
              ),
              props: {
                rowSpan: tableList.value.filter(
                  (item) => item.title == record.title
                ).length
              },
            };
          }
          else

            obj = {
              children: h(
                "span",

                ""
              ),
              props: {
                rowSpan: 0
              },
            };

          return obj;
        },


      },
      {
        dataIndex: "clientName",
        key: "clientName",
        title: "评论人",
        width: "10%",
        align: 'center',
        customCell: (record) => {
          if (record.one == true) {
            return {
              style: {
                'background-color': '#e6f7ff',
                'color': record.readStatus == true ? '#cfcccc' : ''
              }
            }
          }
          else {
            return {
              style: {
                'color': record.readStatus == true ? '#cfcccc' : ''
              }
            }
          }
        }
      },
      {
        dataIndex: "createTime",
        key: "createTime",
        title: "评论时间",
        width: "12%",
        align: 'center',
        customCell: (record) => {
          if (record.one == true) {
            return {
              style: {
                'background-color': '#e6f7ff',
                'color': record.readStatus == true ? '#cfcccc' : ''
              }
            }
          }
          else {
            return {
              style: {
                'color': record.readStatus == true ? '#cfcccc' : ''
              }
            }
          }
        }

      },
      {
        dataIndex: "rowselection1",
        title: '',
        width: "4%",
        align: 'center'
      },
      {
        dataIndex: "comment",
        key: "comment",
        title: "内容",
        align: 'center',
        width: "40%",
        customCell: (record) => {
          if (record.one == true) {
            return {
              style: {
                'background-color': '#e6f7ff',
                'color': record.readStatus == true ? '#cfcccc' : ''
              }
            }
          }
          else {
            return {
              style: {
                'color': record.readStatus == true ? '#cfcccc' : ''
              }
            }
          }
        }
      },
      {
        dataIndex: "action",
        key: "action",
        title: "操作",
        align: 'center',
        width: "10%",
        customRender: ({ record, index }) => {
          var flag = true
          if (record && record.one == true) {

            for (var i in record.replyComments) {
              if (record.replyComments[i].readStatus == false) {
                flag = false
                break
              }
            }
            if (flag == true) {
              if (record.readStatus == false) flag = false
            }
          }

          var obj = {
            children: h('a', {
              onClick: () => {
                flag == true ? null : toWatch(record)
              },
              style: {
                color: flag == true ? '#cfcccc' : '',
                cursor: flag == true ? 'not-allowed' : '',
                'word-break': 'keep-all'
              }
            }, '一键已读'),
            props: {
              rowSpan: record && record.one == true && record.replyComments ? (record.replyComments.length == 0 ? 1 : record.replyComments.length + 1) : 0,



            },

          }




          return obj;
        }

      },

    ])
    const toWatch = (val) => {
      if (reloading.value == false) {
        reloading.value = true
        var ids = []
        var i
        ids.push(val.articleCommentId)
        for (i in val.replyComments) {
          ids.push(val.replyComments[i].articleCommentId)
        }
        readComment(ids).then((res) => {
          if (res.msg == '处理成功') {

            message.success('处理成功')
            for (i in ids) {
              tableList.value.find(item => item.articleCommentId == ids[i]).readStatus = true
              if (tableList.value.find(item => item.articleCommentId == ids[i]).checkbox != null) {
                tableList.value.find(item => item.articleCommentId == ids[i]).checkbox = false
              }

            }
            toRestCheckBox()
          }

          else message.error('处理失败')
          reloading.value = false
        }).catch(() => {
          reloading.value = false
        })
      }



    }


    const onSelectChange = (selectedRowKeys) => {

      state.selectedRowKeys = selectedRowKeys;
    };
    const scrollHeight = ref(0)

    const state = reactive({
      indeterminate: false,
      checkAll: false,

    });
    const toWatchTableList = () => {
      if (tableList.value) {

        var i
        var length = 0
        var result

        var result = tableList.value.filter(item => item.checkbox == true)
        if (result) {
          console.log(result, 'result')
          for (i in result) {
            if (result.findIndex(item => item.title == result[i].title) == i)
              length++

          }

        }



        hasSelected.value = !(length == 0)
        // if (pagination.pageSize > pagination.total) {
        //   state.checkAll = length == pagination.total
        //   state.indeterminate = !(length == pagination.total)

        // } else {
        //   state.checkAll = length == pagination.pageSize
        //   state.indeterminate = !(length == pagination.pageSize)

        // }

        state.checkAll = length == originDataSource.value.length
        if (length == 0) state.indeterminate = false
        else if (length == originDataSource.value.length) state.indeterminate = false
        else state.indeterminate = true

      }
    }
    const onCheckAllChange = (e) => {
      state.checkAll = e.target.checked

      console.log(tableList.value, 'tableList.value')
      var list = tableList.value
      for (var i in list) {
        if (list[i].checkbox != null) list[i].checkbox = e.target.checked
        list[i].checkboxExport = e.target.checked
        if (e.target.checked == true) list[i].checkboxExportDisabled = false
        else list[i].checkboxExportDisabled = true

      }


      tableList.value = list
      nextTick(() => {
        toWatchTableList()
      })



    };
    const onCheckChange = (e, record) => {
      console.log(e)
      var list = tableList.value
      for (var i in list) {
        if (list[i].title == record.title) {
          if (list[i].checkbox != null) list[i].checkbox = e.target.checked
          list[i].checkboxExport = e.target.checked
          list[i].checkboxExportDisabled = !e.target.checked
        }





      }


      tableList.value = list
      nextTick(() => {
        toWatchTableList()
      })





    };
    const onCheckChangeExport = (e, record) => {
      console.log(e)

      var i
      var j
      var result
      var length = 0
      tableList.value.find(item => item.articleCommentId == record.articleCommentId).checkboxExport = e.target.checked
      var list
      if (record.one != true) {
        list = tableList.value
        /*二级评论*/
        //1、查找一级评论
        for (i in list) {
          if (list[i].one == true && list[i].replyComments.find(item => item.articleCommentId == record.articleCommentId)) {
            result = list[i].replyComments
            for (j in result) {

              if (list.find(item => item.articleCommentId == result[j].articleCommentId).checkboxExport == true) {

                length++
              }
            }
            console.log(result.length, 'xixi', length)
            if (length == 0) {
              list[i].checkboxExportInterminate = false
              list[i].checkboxExport = false
            }
            else if (length == result.length) {
              list[i].checkboxExportInterminate = false
              list[i].checkboxExport = true
            }
            else {
              list[i].checkboxExportInterminate = true
              list[i].checkboxExport = false
            }


          }

        }
      }
      else {
        result = record.replyComments

        tableList.value.find((item) => item.articleCommentId == record.articleCommentId).checkboxExportInterminate = false
        list = tableList.value
        if (result) {
          for (i in result) {
            list.find((item) => item.articleCommentId == result[i].articleCommentId).checkboxExport = e.target.checked

          }
        }
      }
      var arrayList = list.filter(item => item.title == record.title)
      if (arrayList) {

        if (arrayList.filter(item => item.checkboxExport == false).length == arrayList.length) {
          list.find(item => item.title == record.title).checkbox = false
        }
        else {
          list.find(item => item.title == record.title).checkbox = true
        }
      }




      tableList.value = list
      nextTick(() => {
        toWatchTableList()
      })





    };
    const hasSelected = ref(false)
    const confrimLoading = ref(false)
    const toSelectRead = () => {
      if (confrimLoading.value == false) {
        reloading.value = confrimLoading.value = true
        var list = []
        for (var i in tableList.value) {
          if (tableList.value[i].checkbox == true) {

            var result = tableList.value.filter(item => item.titleId == tableList.value[i].titleId)
            for (var j in result) {
              list.push(result[j].articleCommentId)
            }

          }
        }
        readComment(list).then((res) => {

          if (res.msg == '处理成功') {

            message.success('处理成功')
            for (i in list) {
              tableList.value.find(item => item.articleCommentId == list[i]).readStatus = true
              if (tableList.value.find(item => item.articleCommentId == list[i]).checkbox != null) {
                tableList.value.find(item => item.articleCommentId == list[i]).checkbox = false
              }
              if (tableList.value.find(item => item.articleCommentId == list[i]).checkboxExportInterminate != null)
                tableList.value.find(item => item.articleCommentId == list[i]).checkboxExportInterminate = false
              tableList.value.find(item => item.articleCommentId == list[i]).checkboxExport = false



            }
            toRestCheckBox()
          }

          else message.error('处理失败')
          reloading.value = confrimLoading.value = false
        }).catch(() => {
          reloading.value = confrimLoading.value = false
        })
      }


    }
    const toRestCheckBox = () => {
      state.checkAll = false
      state.indeterminate = false
    }
    const commentPage = ref(null)
    const handleTableChange = (page, pageSize) => {
      pagination.current =
        pageSize != pagination.pageSize ? 1 : page;
      pagination.pageSize = pageSize;
      pagination.current = page

      const element = document.getElementById("commentPage");

      element.scrollIntoView();
      console.log(commentPage.value, 'commentPage.value')
      toShowTable()


      scrollTo(0, 0)
    }

    return {

      onCheckChangeExport,
      handleTableChange,
      commentPage,

      toRestCheckBox,
      confrimLoading,
      onCheckChange,
      onCheckAllChange,
      scrollHeight,
      state,
      hasSelected,
      onSelectChange,
      toAllRead,
      toSelectRead,
      toWatch,
      originDataSource,
      toExport,
      postData,
      loading,
      columns,
      toSearchUser,
      scrollY,
      changeTime,
      rangeTime,
      visible,
      reloading,
      scrollView,
      tableList,
      toShowTable,
      pagination,
    }
  },
  beforeRouteLeave(to, from, next) {
    //保存滚动条元素div的scrollTop值
    this.scrollY = document.querySelector('.scrollView').scrollTop
    next();
  },
  methods: {

  }
}
</script>
<style>
.tablestyle .ant-table-thead>tr>th,
.ant-table-tbody>tr>td {
  padding: 8px 8px !important;
}

.commentPageStyle .ant-table-measure-row {
  visibility: collapse !important
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.noaction {
  color: gray;
  cursor: not-allowed;
}

.tablestyle {
  margin-top: 20px;
}

.scrollView {
  margin: 10px 0px;
}

.datelist {
  margin-left: 10px;
  display: inline-block;
}

.datelist a {
  margin-right: 10px;
}
</style>